import React, { Component } from 'react';
import { StyleSheet, Image, View, Text, Pressable } from 'react-native';

import CachedImage from '../attachments/cached_image';
import ImageView from '../image_view';
import OPComponent from '../op_component';
import AvatarInitials from '../avatar/initials';

import { COLOR, FONT, FONT_SIZE, __WEB__ } from '../../../constants/styles';

class ProfileAvatar extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      imageError: false,
    };

    this._unMounted = true;
  }

  componentDidMount() {
    this._unMounted = false;
  }
  componentWillUnmount() {
    this._unMounted = true;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.attachment !== this.props.attachment ||
      nextProps.avatarUrl !== this.props.avatarUrl ||
      nextProps.initialsStr !== this.props.initialsStr ||
      nextProps.children !== this.props.children ||
      nextState.imageError !== this.state.imageError
    );
  }
  componentDidUpdate(prevProps, prevState) {
    // if anything has changed other than imageError state then clear the
    // imageError state so we can try to re-render based on the new props
    if (this.state.imageError && prevState.imageError) {
      this.setState({ imageError: false });
    }
  }

  handlePress = () => {
    this.props.onPress && this.props.onPress();
  };

  handleImageError = () => {
    if (this._unMounted) return;
    this.setState({ imageError: true });
  };

  _circleDim(circleStyles) {
    // need StyleSheet.flatten() for web,
    // otherwise you just the get the style's id which doesn't have a .width prop
    if (__WEB__) circleStyles = StyleSheet.flatten(circleStyles);
    const width = (circleStyles && circleStyles.width) || StyleSheet.flatten(styles.circle).width;
    const borderWidth = (circleStyles && circleStyles.borderWidth) || 0;
    return width - borderWidth * 2;
  }

  _circleContainerDim(circleStyles) {
    if (__WEB__) circleStyles = StyleSheet.flatten(circleStyles);

    const width = (circleStyles && circleStyles.width) || StyleSheet.flatten(styles.circle).width;
    return width;
  }

  renderCircle() {
    const { attachment, avatarUrl, initialsStr, circleStyles } = this.props;
    // avatarURL takes precedence (enables overriding the profile avatarURL with a local url)

    const circleDim = this._circleDim(circleStyles);
    const circleDimStyle = {
      width: circleDim,
      height: circleDim,
      borderRadius: circleDim / 2,
    };
    const circleContainerDim = this._circleContainerDim(circleStyles);
    const circleContainerDimStyle = {
      width: circleContainerDim,
      height: circleContainerDim,
      borderRadius: circleContainerDim / 2,
    };
    const circleContainerStyle = {
      ...circleStyles,
      ...circleContainerDimStyle,
    };
    const circleStyle = {
      ...circleDimStyle,
      overflow: 'hidden',
    };

    if (avatarUrl && !this.state.imageError) {
      return (
        <View style={circleContainerStyle}>
          <View style={circleStyle}>
            <ImageView
              imageUri={avatarUrl}
              width={circleDim}
              height={circleDim}
              onImageError={this.handleImageError}
              onPress={null}
            />
          </View>
        </View>
      );
    }

    if (attachment && !this.state.imageError) {
      return (
        <View style={circleContainerStyle}>
          <View style={circleStyle}>
            <CachedImage
              attachment={attachment}
              isThumb={true}
              width={circleDim}
              height={circleDim}
              onImageError={this.handleImageError}
            />
          </View>
        </View>
      );
    }

    if (initialsStr) {
      return (
        <View style={circleContainerStyle}>
          <AvatarInitials nameStr={initialsStr} containerStyles={circleStyle} />
        </View>
      );
    }

    return (
      <View style={circleContainerStyle}>
        <View style={[circleStyle, styles.avatarPlaceholderContainer]}>
          <Image
            style={styles.avatarPlaceholder}
            source={require('../../../../resources/icon-user.png')}
            resizeMode="contain"
          />
        </View>
      </View>
    );
  }

  render() {
    const { nameLabel, nameSubLabel, withSublabel, circleStyles, containerStyles, onPress } =
      this.props;

    const circleDim = this._circleDim(circleStyles);
    const containerStyle = {
      ...styles.container,
      width: circleDim + 10,
      height: circleDim + 10 + (nameLabel ? (withSublabel ? 24 : 12) : 0),
      ...StyleSheet.flatten(containerStyles),
    };

    return (
      <Pressable
        style={[styles.container, containerStyle]}
        onPress={this.handlePress}
        disabled={!onPress}
      >
        {this.renderCircle()}
        {this.props.children}
        {!!nameLabel && (
          <View style={{ marginTop: __WEB__ ? 10 : 7 }}>
            <Text style={withSublabel ? styles.nameTextBold : styles.nameText} numberOfLines={1}>
              {nameLabel.toUpperCase()}
            </Text>
            <Text style={styles.subNameText} numberOfLines={1}>
              {nameSubLabel?.toUpperCase()}
            </Text>
          </View>
        )}
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  circle: {
    width: 120,
    height: 120,
  },
  nameTextBold: {
    ...FONT.bold,
    fontSize: FONT_SIZE.micro,
    color: COLOR.textLight,
    textAlign: 'center',
  },
  nameText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.micro,
    color: COLOR.textLight,
    textAlign: 'center',
  },
  subNameText: {
    ...FONT.regular,
    fontSize: FONT_SIZE.micro,
    color: COLOR.textLight,
    textAlign: 'center',
  },
  avatarPlaceholderContainer: {
    backgroundColor: '#efefef',
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatarPlaceholder: {
    width: 40,
    height: 40,
  },
});

export default ProfileAvatar;
